var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-overlay"},[_c('div',{staticClass:"loading-pane"},[_c('div',{staticClass:"loading-location"},[_c('van-loading',{attrs:{"size":".2rem","color":"#505050","text-color":"#505050"}},[_vm._v("加载中...")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }